import React, {useEffect, useState} from 'react';
import {Checkbox, Toast, Switch, Icon} from 'antd-mobile-v2';
import {useForm} from 'react-hook-form';
import Dayjs from 'dayjs';
import BackHeader from '@comp/BackHeader/index';
import {addPatient} from '@/store/api/user';
import {getUser, storage} from '@/utils/tools';
import {Identification, getBirthFromIDCard, getSexFromIDCard, isMobilePhone, getAgeFromBirth} from '@/utils/verify';

import './index.less';

export default function (props) {
  const cp = storage.get('GU_INFO');
  console.log(props.history);
  const {user_id} = getUser();
  const [form, setForm] = useState({
    family_name: '',
    family_birth: '',
    family_age: '',
    family_phone: '',
    family_sex: '1',
    has_medicare_card: '0',
    is_default: '0',
    id_card: '',
    guardian_uid: cp ? cp.patient_uid : '',
    user_id: user_id,
  });
  const [isCard, setIsCard] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    formState: {errors},
  } = useForm();

  useEffect(() => {
    return () => {
      storage.remove('GU_INFO');
    };
  }, []);

  const onSubmit = async e => {
    console.log(form);
    const {status, message} = await addPatient({
      ...form,
      ...e,
      family_birth: Dayjs().subtract(e.family_age, 'year').format('YYYY-MM-DD'),
      family_age: `${e.family_age}`,
      guardian_uid: cp ? cp.patient_uid : '',
    });
    if (status === '0') {
      Toast.success('添加成功', 2, () => {
        storage.remove('GU_INFO');
        // props.history.push('/patient/list/index');
        history.back();
      });
    } else {
      Toast.fail(message);
    }
  };

  const onChangeForm = (key, val) => {
    console.log('kkk', val);
    if (key === 'id_card') {
      handleIdCard(val);
    } else {
      form[key] = val;
      setForm({...form});
    }
  };

  const handleIdCard = card => {
    console.log(card);
    const flag = Identification.isID(card).result;
    setIsCard(flag);
    if (flag) {
      const birth = getBirthFromIDCard(card);
      const sex = getSexFromIDCard(card);
      const age = getAgeFromBirth(birth);
      // form.family_birth = new Date(birth);
      form.family_birth = birth;
      form.family_age = age;
      form.family_sex = sex;
      form.id_card = card;
      setValue('family_age', age);
      setValue('family_sex', sex);
      setValue('id_card', card);
      setForm({...form});
    }
  };

  const validateCard = v => {
    console.log(v);
    console.log(errors);
    if (!v) return true;
    const {result} = Identification.isID(v);
    return result;
  };

  return (
    <section className="page">
      <BackHeader title="新增就诊人" />
      <article className="main patient-add">
        <form className="form" onSubmit={handleSubmit(onSubmit)}>
          <div className="form-item">
            <label>
              <i className="required">*</i>姓名
            </label>
            <input
              {...register('family_name', {required: true})}
              type="text"
              placeholder="请输入真实姓名"
              maxLength={10}
              onChange={e => onChangeForm('family_name', e.target.value)}
            />
            {errors.family_name && <span className="error">姓名不能为空</span>}
          </div>
          <div className="form-item">
            <label>身份证号</label>
            <input
              type="text"
              placeholder="请输入身份证号码"
              onInput={e => onChangeForm('id_card', e.target.value)}
              {...register('id_card', {validate: v => validateCard(v)})}
            />
            {errors.id_card && <span className="error">身份证号码不正确</span>}
          </div>
          <div className="form-item">
            <label>
              <i className="required">*</i>性别
            </label>
            <div className="checkbox-group">
              <Checkbox
                disabled={isCard}
                checked={form.family_sex === '1'}
                onChange={() => onChangeForm('family_sex', '1')}
              >
                <span className="label">男</span>
              </Checkbox>
              <Checkbox
                disabled={isCard}
                checked={form.family_sex === '2'}
                onChange={() => onChangeForm('family_sex', '2')}
              >
                <span className="label">女</span>
              </Checkbox>
            </div>
            <input type="hidden" value={form.family_sex} {...register('family_sex', {required: true})} />
          </div>
          <div className="form-item birth">
            {/*<DatePicker*/}
            {/*  mode="date"*/}
            {/*  extra="请选择日期"*/}
            {/*  minDate={new Date('1900-01-01')}*/}
            {/*  maxDate={new Date()}*/}
            {/*  disabled={isCard}*/}
            {/*  value={form.family_birth}*/}
            {/*  onChange={date => onChangeForm('family_birth', date)}*/}
            {/*>*/}
            {/*  <List.Item>*/}
            {/*    <i className="required">*</i>生日*/}
            {/*  </List.Item>*/}
            {/*</DatePicker>*/}
            <label>
              <i className="required">*</i>年龄
            </label>
            <input
              type="text"
              placeholder="请输入年龄"
              disabled={isCard}
              defaultValue={form.family_age}
              onInput={e => onChangeForm('family_age', e.target.value)}
              {...register('family_age', {
                required: true,
                validate: v => {
                  return Number.isInteger(Number(v));
                },
                max: 120,
                min: 1,
              })}
            />
            {errors.family_age && <span className="error">年龄不正确</span>}
          </div>
          <div className="form-item">
            <label>
              <i className="required">*</i>手机号
            </label>
            <input
              type="text"
              placeholder="请输入手机号"
              maxLength={11}
              onChange={e => onChangeForm('family_phone', e.target.value)}
              {...register('family_phone', {required: true, validate: v => isMobilePhone(v)})}
            />
            {errors.family_phone && <span className="error">手机号码不正确</span>}
          </div>
          <div className="form-item">
            <div className="lft">是否有医保卡</div>
            <Switch
              checked={form.has_medicare_card === '1'}
              onChange={checked => onChangeForm('has_medicare_card', `${Number(checked)}`)}
            />
          </div>
          <div className="form-item">
            <div className="lft">
              <span>设为默认就诊人</span>
              <span className="tip">注：每次下单时会使用该就诊人</span>
            </div>
            <Switch
              checked={form.is_default === '1'}
              onChange={checked => onChangeForm('is_default', `${Number(checked)}`)}
            />
          </div>
          {form.family_age <= 6 ? (
            <div className="form-item" onClick={() => props.history.push('/patient/list/selectguardian')}>
              <div className="lft">
                <span>监护人</span>
                <span className="tip">注：6岁以下儿童须关联就诊人</span>
              </div>
              <div className="link">
                <span>{cp ? cp.patient_name : '未选择'}</span>
                <Icon type="right" />
              </div>
            </div>
          ) : (
            ''
          )}
          <input type="submit" className="btn-next" value="保存" />
        </form>
      </article>
    </section>
  );
}
